import React from 'react';
import { CtaButton } from './CtaButton';
import { extras } from '../data/content';
export function Extras() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8 md:py-20" data-id="element-90" data-mp="1hd4pq6axuw5c">
      <div className="mx-auto max-w-3xl text-center" data-id="element-91" data-mp="13nks1ew7sp2w">
        <h2 className="font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-92" data-mp="13msz6bu055gb">
          📲 You’ll also get instant access to:
        </h2>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-93" data-mp="tntv76k6lxzn">
        {extras.map(extra => <li key={extra.title} className="flex h-full flex-col rounded-2xl border border-ink/10 bg-cream p-5" data-id="element-94" data-mp="yp9i745x6eko">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-95" data-mp="op8vd88udgbq">
              {extra.icon}
            </span>
            <h3 className="mt-3 font-display text-[19px] font-bold text-ink" data-id="element-96" data-mp="2f39g69l7fu5a">{extra.title}</h3>
            <p className="mt-2 text-[14px] leading-snug text-clay" data-id="element-97" data-mp="2j434v56h1cz8">{extra.text}</p>
          </li>)}
      </ul>

      <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-98" data-mp="108o551ex04kh">
        <p className="font-display text-[22px] font-bold leading-snug text-ink sm:text-3xl" data-id="element-99" data-mp="vb5rwytv736o">
          Whatever anterior composite case walks into your practice, you won’t start from a
          blank page.
        </p>
        <p className="mt-4 text-[14px] font-semibold uppercase tracking-[0.08em] text-clay" data-id="element-100" data-mp="150fn4nk091z0">
          You’ll have a system to help you
        </p>
        <p className="mt-3 rounded-2xl bg-ink px-4 py-4 text-[12px] font-bold uppercase leading-relaxed tracking-[0.1em] text-gold-light sm:text-sm" data-id="element-101" data-mp="hd7k6ca1u505">
          Assess → Decide → Plan → Execute → Review
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-102" data-mp="mahg8ary1ewy">
        <CtaButton label="Get access to the complete system" data-id="element-103" data-mp="m8mu4t4xrgra" />
      </div>
    </section>;
}